module.exports = __webpack_public_path__ + "static/media/t_cs.79c8163e.pdf";